
import React from "react";

export const TimeLoading = ({ width = 40, height = 40 }: { width?: number; height?: number }) => (
<svg
  width={width}
  height={height}
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M19.9993 15V20L23.9993 24"
    stroke="#FCB041"
    strokeWidth="2.05"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.9661 9.13L10.2371 14.927L15.9291 13.341"
    stroke="#FCB041"
    strokeWidth="2.05"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.237 14.927C11.4762 12.5398 13.5471 10.6893 16.0581 9.72547C18.5692 8.76162 21.3464 8.7512 23.8646 9.69616C26.3828 10.6411 28.4676 12.476 29.7247 14.8538C30.9817 17.2317 31.3241 19.9877 30.6869 22.6008C30.0497 25.2139 28.4772 27.5031 26.2666 29.0354C24.0561 30.5677 21.3608 31.2369 18.6902 30.9167C16.0197 30.5964 13.559 29.3088 11.7734 27.2973C9.98791 25.2857 9.00124 22.6897 9 20"
    stroke="#FCB041"
    strokeWidth="2.05"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

);
 